import { render, staticRenderFns } from "./DynamicInfoList.vue?vue&type=template&id=27364ae3&scoped=true&"
import script from "./DynamicInfoList.vue?vue&type=script&lang=ts&"
export * from "./DynamicInfoList.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicInfoList.vue?vue&type=style&index=0&id=27364ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27364ae3",
  null
  
)

export default component.exports